import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GET_GSC_CONTINUE_APPLICATION_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostContinueApplication = ({ onSuccess, onError }: Input) => {
  const postContinueApplication = async (uuid: string) => {
    await axiosClient.post(GET_GSC_CONTINUE_APPLICATION_URL(uuid));
  };

  return useCustomMutation(postContinueApplication, {
    onSuccess,
    onError,
  });
};
